import React from 'react'
import styled from 'styled-components'
import { Grid as BaseGrid } from '@material-ui/core'
import { WarningIcon as BaseWarningIcon } from '@chilecompra/react-kit/components'

export const Root = styled.div`
  box-sizing: border-box;
  padding: 0 0 130px;
  width: 100%;
`

export const DesktopNavigation = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 30px;
  margin: 0 0 0 30px;

  ${props => props.theme.breakpoints.down('md')} {
    justify-content: center;
    margin: 0;
  }
`

export const MobileNavigation = styled.div`
  align-items: center;
  background-color: ${props => props.theme.palette.custom.ghostWhite};
  bottom: 0;
  box-shadow: 0 -3px 10px ${props => props.theme.palette.custom.ghostBlack};
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 32px;
  height: 90px;
  justify-content: center;
  left: 0;
  position: fixed;
  width: 100%;
`

export const Section = styled(({ margin, maxWidth, padding, ...props }) => <BaseGrid {...props} />)`
  margin: ${props => props.margin || 'initial'};
  max-width: ${props => props.maxWidth};
  padding: ${props => props.padding || 'initial'};
`

export const Title = styled.h1`
  color: ${props => props.theme.palette.custom.mineShaft};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 34px;
  font-weight: 300;
  letter-spacing: 0;
  margin: 0;

  ${props => props.theme.breakpoints.only('xs')} {
    text-align: center;
  }
`

export const Instructions = styled.p`
  color: ${props => props.theme.palette.custom.charcoal};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 22px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 1.3;
  margin: 0;

  ${props => props.theme.breakpoints.only('xs')} {
    text-align: center;
  }
`

export const ExternalLink = styled.a`
  color: ${props => props.theme.palette.brand.primary};

  &:hover {
    text-decoration: underline;
  }
`

export const ModalContent = styled.div`
  box-sizing: border-box;
  height: 100%;
  padding: 29px 10px;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${props => props.theme.breakpoints.only('sm')} {
    padding: 59px 30px;
  }

  ${props => props.theme.breakpoints.down('xs')} {
    padding: 59px 0;
  }
`

export const ModalTitle = styled.h2`
  color: ${props => props.theme.palette.custom.charcoal};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 22px;
  font-weight: bold;
  margin: 0 0 32px;
  text-align: center;
`

export const ModalText = styled.p`
  color: ${props => props.theme.palette.custom.charcoal};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  font-weight: 300;
  margin: 0 0 31px;
  text-align: center;
`

export const ModalAction = styled.p`
  margin: 0 0 17px;
  text-align: center;
`

export const ModalInstructions = styled.p`
  color: ${props => props.theme.palette.custom.charcoal};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 12px;
  margin: 0;
  text-align: center;
`

export const Strong = styled.span`
  font-weight: bold;
`

export const LinkHelp = styled('a')`
  align-items: center;
  color: ${props => props.theme.palette.blue[50]};
  cursor: pointer;
  font-weight: 400;
  font-size: 14px;
  text-decoration: none;
  pointer-events: visible;

  &:hover {
    color: ${props => props.theme.palette.blue[35]};
    text-decoration: underline;
  }
`

export const WarningContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-bottom: 20px;
  background-color: rgb(254, 244, 221);
  border: 1px solid rgb(254, 244, 221);
`

export const WarningIcon = styled(BaseWarningIcon)`
  &.MuiSvgIcon-root {
    color: rgb(247, 193, 55);
    font-size: 1.2rem;
    margin: 0;
  }
`
